import { BUSINESS } from "@/data/content";

export default function SeoSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    name: "Sero's Restaurant",
    servesCuisine: ["American", "Wood-Fire Grill", "Seafood"],
    priceRange: "$$$",
    telephone: BUSINESS.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: "375 W 12 Mile Rd",
      addressLocality: "Madison Heights",
      addressRegion: "MI",
      postalCode: "48071",
      addressCountry: "US",
    },
    openingHours: ["Mo-Su 07:00-21:00"],
    acceptsReservations: "True",
    menu: "#menu",
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
